import { createSelector } from '@ngrx/store';
import { getChartState } from 'ChartApp/ts/features/fund-chart-page-shared/state/fund-chart-base.selectors';
export const getAISummaryEvents = createSelector(getChartState, (chartState) => {
    return chartState?.aiSummaries ?? [];
});
